import { generatePath } from 'react-router';

import { getChannelStatus, getPublishStatus } from './statuses';

import { PUBLISH_ACTION } from '../../constants/listings';
import { PARAMS, ROUTES } from '../../constants/routes';

const { ROOT, SHOP: { LISTINGS, ROOT: SHOP }} = ROUTES;

export function getListingsPath(state) {
  const shopId = state.getIn(['shops', 'current']);

  if (!shopId) return ROOT;

  const channel = state.getIn(['shops', 'byId', shopId, 'channel']);
  const status = state.getIn(['listings', 'status']);
  const path = `${SHOP}${LISTINGS.ROOT}${LISTINGS.STATUS}`;
  const params = {
    [PARAMS.SHOP_ID]: shopId,
    [PARAMS.STATUS]: (
      getChannelStatus({ channel, status }) ||
      getPublishStatus({ action: PUBLISH_ACTION.PUBLISH, channel })
    ),
  };

  return generatePath(path, params);
}
